import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";
import Modal from "@shared/v2/Modal";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

let cachedAgentPromise = null;

const ReassignModal = ({
  assignedToUserId,
  onSelectAgent,
  onClose,
  onReassignTasks,
  submitDisabled,
  taskCount,
}) => {
  const [agentsOptions, setAgentsOptions] = useState([]);
  useEffect(() => {
    if (!cachedAgentPromise) {
      cachedAgentPromise = caseTransformingAxios.get("/simple_account_active_agents").then((response) =>
        [{ label: "Anyone", value: "anyone" }].concat(
          response.data.map((agent) => ({
            label: agent.fullName,
            value: agent.uuid,
            email: agent.email,
          })),
        ),
      );
    }
    cachedAgentPromise.then(setAgentsOptions);
  }, []);

  return (
    <Modal
      id="reassign-task-modal"
      show
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header
        title={`Do you really want to reassign ${taskCount} task${taskCount > 1 ? "s" : ""}`}
        closeButton
      />

      <Modal.Body>
        <Dropdown
          label="Assign these Tasks to"
          isSearchable
          name="assigned_to_user_id"
          onChange={onSelectAgent}
          value={agentsOptions.find((o) => o.value === assignedToUserId)}
          options={agentsOptions}
        />
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" isLoading={submitDisabled} onClick={onReassignTasks}>
          Reassign
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ReassignModal.propTypes = {
  assignedToUserId: PropTypes.string.isRequired,
  onSelectAgent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onReassignTasks: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool,
  taskCount: PropTypes.number.isRequired,
};

ReassignModal.defaultProps = {
  submitDisabled: false,
};

export default ReassignModal;
